/**
 * Global Modal Stack
 * 
 * Public API for the global modal stack system.
 * 
 * @example
 * import { GlobalModalStackProvider, useGlobalModalStack, GLOBAL_MODAL_IDS, MODAL_IDS, ModalContainer } from "@wtc/ui";
 * 
 * // In your app root
 * <GlobalModalStackProvider syncWithUrl>
 *   <App />
 * </GlobalModalStackProvider>
 * 
 * // In your components
 * const { openModal, closeModal, isModalOpen } = useGlobalModalStack();
 */

// Main exports
export { GlobalModalStackProvider } from "./GlobalModalStackProvider";
export { useGlobalModalStack, GlobalModalStackContext } from "./context";
export { GLOBAL_MODAL_IDS, MODAL_IDS } from "./constants";
export { ModalContainer } from "./ModalContainer";

// Type exports
export type { GlobalModalId, GlobalModalStackContextType, GlobalModalStackProviderProps } from "./types";
export type { ModalContainerProps } from "./ModalContainer";

// Hook exports (for advanced usage)
export { useModalDataStore } from "./hooks/useModalDataStore";
export { useUrlSync } from "./hooks/useUrlSync";
export { useModalActions } from "./hooks/useModalActions";

// Type exports for hooks (for advanced usage)
export type { ModalDataStoreReturn } from "./hooks/useModalDataStore";
export type { UrlSyncReturn } from "./hooks/useUrlSync";
export type { ModalActionsReturn } from "./hooks/useModalActions";
